module.exports = __webpack_public_path__ + "media/images/icon-focusing@3x-ef92b9428f7efbd9d33425fa73038fef.png";